import Marquee from "react-fast-marquee";
import { useLang } from "../i18n";

const Diamond = () => (
  <svg viewBox="0 0 10 10" className="mx-10 h-2.5 w-2.5 shrink-0" aria-hidden="true">
    <rect x="1.8" y="1.8" width="6.4" height="6.4" fill="#D4A017" transform="rotate(45 5 5)" />
  </svg>
);

export const EditorialMarquee = () => {
  const { t } = useLang();
  return (
    <div data-testid="editorial-marquee" className="border-y border-oris-gold/20 bg-oris-green py-5">
      <Marquee speed={28} gradient={false} pauseOnHover>
        {t.marquee.map((item, i) => (
          <span key={i} className="flex items-center whitespace-nowrap">
            <span className="font-serif text-xl italic tracking-wide text-oris-cream/90 lg:text-2xl">{item}</span>
            <Diamond />
          </span>
        ))}
      </Marquee>
    </div>
  );
};
